import { render, staticRenderFns } from "./VacationTab.vue?vue&type=template&id=e080b336&"
import script from "./VacationTab.vue?vue&type=script&lang=js&"
export * from "./VacationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports